module.exports = __webpack_public_path__ + "img/SearchOnlineCarsLogoWhiteOutlineTransparentSilhouette.c3eb751a.png";